export default ({ vtag,data,beforeValue }) => {
  const colorClass= (val)=>{
    if(+val===0) {
      return '';
    }
    if(val.startsWith('-')){
      return 'report-compare-cell--red';
    }
    if(!val.startsWith('-')) {
      return 'report-compare-cell--green';
    }
    return '';
  }
  const val1 = vtag('span', {class: 'report-compare-cell1'}, [beforeValue,data[0]]);
  const val2 = vtag('span', {class:  `report-compare-cell2 ${colorClass(data[2])}`}, [data[2]]);
  const val3 = vtag('span', {class: 'report-compare-cell3'}, [beforeValue,data[1]]);
  const val4 = vtag('span', {class:  `report-compare-cell4 ${colorClass(data[3])}`}, [data[3] + '%'] );

  return vtag('div', { class:'report-compare-cell'}, [val1, val2, val3, val4]);
}
